<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Edit Docs Template</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <template v-if="editTemplate">

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="name" v-model="docsTemplateDescription.name" v-validate="'required'"
                  data-vv-as="Name" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{ errors.first("name") }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Description:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="description" v-model="docsTemplateDescription.description"
                  v-validate="'required'" data-vv-as="Fields Description" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('description')">{{
                errors.first("description")
              }}</span>
            </div>
            <div class="m-5  warning">
              <p><strong>Note : </strong> The text inside single curly braces { } will be recognized as variable. </p>
            </div>

            <!-- <vue2-tinymce-editor :options="tinmymce_options" v-model="docsTemplateDescription.template_text"></vue2-tinymce-editor> -->
            <div id="edit_text_editor">

            
            <vue-trumbowyg
            v-model="docsTemplateDescription.template_text"
            :config="configs.basic"></vue-trumbowyg>
            </div>

            <div class="text-center">
              <div class="p-4">
                <vs-button class="mb-2" @click.prevent="submitForm">Submit</vs-button>

              </div>
              <div>

              </div>
            </div>
          </template>
          <template v-if="assignVariables">




            <div class="vx-row mb-6">

              <vs-row vs-w="12">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
                  <h6>Search</h6>
                </vs-col>
                <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                  <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
                    :searchOn="'campaign'" @event-name="handleChildEvent"></CampaignAutocomplete>


         </vs-col>

                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">


                  {{selected_campaign_name }}       


                </vs-col>


              </vs-row>







            </div>

        

            <template v-if="selected_campaign">

              <div class="text-left m-10">
                

                <div class="warning pb-10">
                  <p><strong>Note : </strong> Please select campaign to assign fields to a variables. </p>
                  <p> Choosing multiple fields will be created as table on the docs.</p>
                </div>

                <vs-row vs-w="12" class="p-5 ml-10" v-for="v, index in savedVariables">
                  <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">


                    <h6>{{ v.docs_template_variable_variable }}</h6>
                  </vs-col>
                  <vs-col vs-lg="7" vs-sm="4" vs-xs="12">
                    <v-select multiple :closeOnSelect="false" :options="acc_con_columns" :key="index" label="name"
                      v-model="v.value" />
                  </vs-col>
             
                </vs-row>

                <div class="text- p-5">

                  <span class="text-danger text-sm">{{
                    field_variable_eror_msg
                  }}</span>
                </div>

                <div class="text-left">
                  <vs-button @click.prevent="updateVariable">Update Variable</vs-button>

                </div>



              </div>





              <div>

              </div>


            </template>



          </template>


        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
// import { Vue2TinymceEditor } from "vue2-tinymce-editor";


import VueTrumbowyg  from 'vue-trumbowyg';

import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'

export default {
  beforeMount() {
  },
  data() {
    return {
      configs: {
        basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['superscript', 'subscript'],
                    ['table', 'tableCellBackgroundColor', 'tableBorderColor'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['viewHTML'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },

                    }
                        }
      },
      tinmymce_options:{deprecation_warnings:false},
      variable_field_sucess : true,
      opp_columns:[],
      field_variable_eror_msg: null,
      previous_template_text: null,
      acc_con_columns: [],
      selected_campaign: [],
      companySearchComponentKey: 0,
      account_columns: [],
      contact_columns: [],
      csv_table_columns: [],
      editor: null,
      variable_fields: [],
      savedVariables: [],
      assignVariables: false,
      editTemplate: true,

      editorConfig: {
        extraPlugins: 'justify,colorbutton',
        // The configuration of the editor.
      },
      docsTemplateDescription: [],
      docsTemplateId: null,
      selected_campaign_id: null,
      selected_campaign_name : null,
      campaign_required: null,
      companySearchComponentKey: 0,
      please_choose_grades: null,
      selected: [],
      abilities: null,
      docsTemplateDescription: {
        name: null,
        description: null,
        template_text: null,
        user_id: null,
        variables: [],
      },
    };
  },
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
    // Vue2TinymceEditor,
    VueTrumbowyg,

    // quillEditor
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
    
    this.docsTemplateId = this.$route.params.docsTemplateId;
    this.fetchDocsTemplate()

  },
  watch: {
  },
  methods: {
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas
      self.selected_campaign = result[0]
      console.log(self.selected_campaign)
      self.fetchClientViewAccountFields()



    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name: data[property].campaign_name + '  -   ' + data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }


              const key = 'id';

const newMappedArray = [...new Map(mappedArray.map(item => [item[key], item])).values()];              
  



  return newMappedArray;


            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewAccountFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewAccountFields",
          selected_campaign_id
        )
        .then(response => {
          this.account_columns = response.data;

          // let acc_columns = []
          // this.account_columns.forEach(e => acc_columns.push(e.column_name))
          // this.account_columns = acc_columns

          self.fetchClientViewOpportunityFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewOpportunityFields",
          selected_campaign_id
        )
        .then(response => {
          this.opp_columns = response.data;

          // let opp_columns = []
          // this.opp_columns.forEach(e => opp_columns.push(e.column_name))
          // this.opp_columns = opp_columns

          self.fetchClientViewContactFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewContactFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewContactFields",
          selected_campaign_id
        )
        .then(response => {
          this.contact_columns = response.data;

          // let con_columns = []
          // this.contact_columns.forEach(e => con_columns.push(e.column_name))
          // this.contact_columns = con_columns



          this.acc_con_columns = [...this.account_columns, ...this.contact_columns , ...this.opp_columns];


          this.acc_con_columns = this.acc_con_columns.filter(e => e.identifier != 'ddi_phone_code' && e.identifier != 'mobile_phone_code' && e.identifier != 'phone_code' && e.identifier != 'switchboard_phone_code' && e.identifier != 'phone_type')


          let sales_developer = {
            column_id: "sales_developer",
            field_type: "sales_developer",
            name: "Sales Developer",
          }


          this.acc_con_columns.push(sales_developer)




        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    updateVariable() {
      var self = this;
      let v_f = []

      let campaign_id = self.selected_campaign.id

      self.savedVariables.forEach(function (e) {
        e.campaign_id = campaign_id
      })









      if (self.savedVariables.length == 0) {
        self.field_variable_eror_msg = "Please select fields for the template variables"
        return false
      } else {

        self.savedVariables.forEach(function (e) {




          if (e.value == null) {
            self.field_variable_eror_msg = "Please choose fields for the variable : " + e.docs_template_variable_variable
            self.variable_field_sucess = false
          }else{
            self.field_variable_eror_msg = null
            self.variable_field_sucess = true


            // if (Array.isArray(e.value)){
              

            //   e.value = e.value.map(function (e) {
            //     return e.column_id
            //   })
            // }else{

            //     if (e.value.hasOwnProperty('column_id')) {
            //   e.value = e.value.column_id
            //   }
            // }




          }

         

        })

        if (self.variable_field_sucess == false) {
          return false
        }


        // console.log(self.savedVariables)
        // return false







        this.$store.dispatch("campaignsManagement/updateDocsTemplateVariable", self.savedVariables)
          .then(res => {
            this.$vs.notify({
              color: "success",
              title: "Docs Template",
              text: res.data.message
            });
            this.$router.go(0);
          })
          .catch(err => {
            console.log(err);

            if (err.response.status === 401) {
              this.$router.replace("/login");
            }
          });

      }



    },
    fetchDocsTemplate() {
      this.$store
        .dispatch("campaignsManagement/fetchDocsTemplate", this.docsTemplateId)
        .then(res => {
          this.docsTemplateDescription = res.data;
          this.previous_template_text = this.docsTemplateDescription.template_text

        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this


      self.$validator.validateAll().then(result => {
        if (result) {
          self.updateDocsTemplate();
        }
      });
    },
    setVariables(template_text) {
      var found = [],          // an array to collect the strings that are found
        rxp = /{+([^}]+)}+/g,
        str = template_text,
        curMatch;

      while (curMatch = rxp.exec(str)) {
        found.push(curMatch[1]);
      }

      this.docsTemplateDescription.variables = found

    },
    fetchCampaign(campaign_id) {
      let self = this
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaign",
          campaign_id
        )
        .then(res => {








          self.selected_campaign = res.data;
          self.selected_campaign_name = self.selected_campaign.campaign_name


      console.log(self.selected_campaign)
      self.fetchClientViewAccountFields()
        

        })
        .catch(err => {
          console.error(err);
        });
    },
    updateDocsTemplate() {
        let self = this
      this.setVariables(this.docsTemplateDescription.template_text)

      this.docsTemplateDescription.user_id = this.user_id


      this.fetchCampaign(this.docsTemplateDescription.campaign_id);



      console.log(this.docsTemplateDescription)
      // return false


      this.$store.dispatch("campaignsManagement/updateDocsTemplate", this.docsTemplateDescription)
        .then(res => {

          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Docs Template",
              text: res.data.message
            });
          } else {

            let response_data = [] 

            if (Array.isArray(res.data)){
              response_data = res.data
            }else{
              response_data = JSON.parse(res.data)

            }


            this.savedVariables = response_data




            this.savedVariables.forEach(function(e){

              if (Array.isArray(e.value)){
                e.value = e.value.map(function(e){
                  return JSON.parse(e)
                })
            }else{
              e.value = JSON.parse(e.value)
            }
            })



            
            let saved_variables = []
            response_data.forEach(function(e){ 
              saved_variables.push(e.docs_template_variable_variable)
            })


            let resultList = self.docsTemplateDescription.variables.filter(x => !saved_variables.includes(x))
            resultList.forEach(function(f){
                self.savedVariables.push({
                        'docs_template_variable_variable': f,
                        'value': null,
                        'docs_template_variable_uuid' : null,
                        'docs_template_variable_docs_template_id' : self.$route.params.docsTemplateId

                })
              })
  

            this.editTemplate = false
            this.assignVariables = true
            document.getElementById("edit_text_editor").classList.add("edit_text_box");


          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.ql-class {
  height: 400px;

}
</style>

<style>
body {
  font-family: "Montserrat", Helvetica, Arial, sans-serif !important;
  font-weight: 400;
}

:root {
  --tbw-cell-vertical-padding: 4px;
  --tbw-cell-horizontal-padding: 8px;
  --tbw-cell-line-height: 1.5em;
}

table {
  margin-bottom: var(--tbw-cell-line-height);
}

th,
td {
  height: calc(var(--tbw-cell-vertical-padding) * 2 + var(--tbw-cell-line-height));
  min-width: calc(var(--tbw-cell-horizontal-padding) * 2);
  padding: var(--tbw-cell-vertical-padding) var(--tbw-cell-horizontal-padding);
  border: 1px solid #e7eaec;
}


.edit_text_box {
  display: none;
}

</style>